module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	fox.registerWidget('AMCFlashPlayer', {
		createFlashPlayer: function () {
			var flashSrc;

			if (fox._isNewfe) {
				flashSrc = require('../flash/flowplayer.commercial-3.2.16.swf');
			} else {
				flashSrc = fox.getEnv('design.url') + "/flash/flowplayer.commercial-3.2.16.swf";
			}

			this.window.flowplayer(
				this.getOption('domNodeContainerLink') === true ? this.getPlayerContainer() : this.getPlayerContainer().getAttribute('id'),
				{
					src: flashSrc,
					wmode: this.getOption('wmode')
				},
				this.getOption('playerConfig')
			);
		}
	}, 'Content_FlashPlayer');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/flashplayer.js
// module id = 835
// module chunks = 4